import CarteiraConstans from "../../infra/data/carteiraConstants";
import { Get } from "domain/infra/data/api";
import { DetalhePagamentoRequest } from "../../types/detalheResgate/detalhePagamentoRequest";
import { DetalhePagamentoResponse } from "../../types/detalheResgate/detalhePagamentoResponse";
import { PagamentoRequest } from "../../types/detalheResgate/pagamentoRequest";
import { PagamentoResponse } from "../../types/detalheResgate/pagamentoResponse";

export class DetalhePagamentoService {
  constructor() {
    //super()
  }
  async GetPagamentos(data: PagamentoRequest, carteiraId: number): Promise<PagamentoResponse[] | Error> {
    return await Get(`${CarteiraConstans.apiCarteira.carteira.getPagamento(carteiraId)}?dataOperacao=${data}`);
  }

  async GetDetalhePagamento(data: DetalhePagamentoRequest, carteiraId: number): Promise<DetalhePagamentoResponse[] | Error> {
    return await Get(`${CarteiraConstans.apiCarteira.carteira.getPagamentoDetalhado(carteiraId)}?dataOperacao=${data}`);
  }

  async GetPagamentoDetalheByExtratoID(data: DetalhePagamentoRequest, carteiraId: number): Promise<DetalhePagamentoResponse[] | Error> {
    return await Get(`${CarteiraConstans.apiCarteira.carteira.getPagamentoDetalhadoByID(carteiraId)}?extratoID=${data.ExtratoID}`);
  }
}
